import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Drawer, DrawerBody, DrawerOverlay, DrawerContent } from '@chakra-ui/react';
export default function MobileModal(props) {
  var isOpen = props.isOpen,
      onClose = props.onClose,
      children = props.children;
  return /*#__PURE__*/_jsxs(Drawer, {
    placement: 'bottom',
    onClose: onClose,
    isOpen: isOpen,
    children: [/*#__PURE__*/_jsx(DrawerOverlay, {}), /*#__PURE__*/_jsx(DrawerContent, {
      children: /*#__PURE__*/_jsx(DrawerBody, {
        padding: "32px",
        children: children
      })
    })]
  });
}